export default {
    disease: 'disease',
    diseaseTitleFa: 'disease Title Fa',
    diseaseTitleEn: 'disease Title En',
    diseaseStatus: 'Status',
    diseases: 'diseases',
    editDisease: 'edit Disease',
    addDisease: 'add Disease',
}